import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { SectionContainer } from '../../containers/Nav/Section';
import ListAltIcon from '@material-ui/icons/ListAlt';

import { AnchorListItem } from './AnchorListItem';
import { NavLinkListItem } from './NavLinkListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { PageLink } from '../../types/pageLink';
import { NavLinkProps } from 'react-router-dom';
const { AionQuestionnaireBuilderUI } = AppName;
const { REACT_APP_NAME } = process.env;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      '& > a.active .MuiTypography-root': {
        color: 'var(--dark-blue)',
        fontWeight: theme.typography.fontWeightMedium
      }
    }
  })
);

type ExtPageLink = PageLink & {
  isActive?: NavLinkProps['isActive'];
};

export const QuestionnaireBuilderSection: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const pages: ExtPageLink[] = [
    {
      id: 'questions',
      path: '/',
      label: t('components.questionnaireBuilder.pages.questions', 'Questions'),
      isActive: (match, location) => {
        return !!match || location.pathname.startsWith('/question');
      }
    },
    {
      id: 'sections',
      path: '/sections',
      label: t('components.questionnaireBuilder.pages.sections', 'Sections'),
      isActive: (match, location) => {
        return !!match || location.pathname.startsWith('/sections/section');
      }
    }
  ];

  const renderPage = (page: ExtPageLink) => {
    if (REACT_APP_NAME === AionQuestionnaireBuilderUI) {
      return (
        <NavLinkListItem exact to={page.path} inset isActive={page.isActive}>
          {page.label}
        </NavLinkListItem>
      );
    }
    return (
      <AnchorListItem href={'/questionnaire-builder' + page.path} inset>
        {page.label}
      </AnchorListItem>
    );
  };

  return (
    <SectionContainer
      id="QuestionnaireBuilder"
      icon={<ListAltIcon />}
      subheader={t('components.questionnaireBuilder.sectionTitle', 'Questionnaire Config')}
    >
      <div className={classes.list}>
        {pages.map(page => (
          <React.Fragment key={page.id}>{renderPage(page)}</React.Fragment>
        ))}
      </div>
    </SectionContainer>
  );
};
